import { DriverSelect } from 'browser/components/atomic-elements/atoms/select/driver-select/driver-select'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const DriverSelectField = LabelFieldFactory({ InputComponent: DriverSelect })
export { DriverSelectField }
